import { format } from 'date-fns'

import s from './SubscriptionHistory.module.scss'

import transformUTCToLocale from 'utils/transformUTCToLocale'

import { useFetch } from 'hooks/useFetch'

import { settingsApi } from 'api/settings-api'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { ModalFullScreen } from 'components/UI/ModalFullScreen/ModalFullScreen'

interface Props {
  onHide: () => void
  show: boolean
}

export const SubscriptionHistory = ({ onHide, show }: Props) => {
  const { data: subsHistory, loading } = useFetch<{ subscriptions: { subs_start: string; subs_end: string }[] }>({
    getData: settingsApi.getSubscriptionHistory,
  })

  return (
    <ModalFullScreen show={show} onHide={onHide} className={s.modalWrapper} loading={loading}>
      <div>
        <h1 className={s.title}>Subscription history</h1>
        {subsHistory?.subscriptions?.length ? (
          <table className={s.table}>
            <thead className={s.head}>
              <tr>
                <th className={s.headText}>Since</th>
                <th className={s.headText}>Until</th>
              </tr>
            </thead>
            <tbody>
              {subsHistory?.subscriptions?.map((row) => (
                <tr key={row.subs_start} className={s.tableRow}>
                  <td className={s.tableData}>{format(transformUTCToLocale(row.subs_start), 'MMM dd yyyy HH:mm')}</td>
                  <td className={s.tableData}>{format(transformUTCToLocale(row.subs_end), 'MMM dd yyyy HH:mm')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className={s.noData}>Your subscription history empty</p>
        )}
      </div>
      <CustomButton variant="outlined" onClick={onHide} size="152">
        Close
      </CustomButton>
    </ModalFullScreen>
  )
}
